<script lang="ts">
  import { addRoute } from '@integro/core';
  import { gettext, pgettext, ngettext, npgettext } from '@integro/gettext';
  addRoute({
    name: 'settings.registers',
    path: 'registers',
    component: 'Registers',
    title: () => pgettext('Registers|Title', 'Configure registers'),
  });
</script>

<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    userComponentProps,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'Registers',
  });

  const componentMetadata = {
    kind: 'page',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    ...userComponentProps,
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const onRegisterSaved = (...args) => {
    const data = args[0];
    const idx = _.findIndex(items.value, { id: data.id });

    if (idx == -1) {
      items.value.push(data);
    } else {
      items.value[idx] = data;
    }
    selectedRegister.value = data;
    createRegister.value = false;
  };
  const onRegisterDeleted = (...args) => {
    const data = args[0];
    _.remove(items.value, { id: data.id });

    if (previousSelectionId.value) {
      const match = _.find(items.value, { id: previousSelectionId.value });
      if (match) {
        selectedRegister.value = match;
      }
    }

    if (items.value.length) {
      selectedRegister.value = items.value[0];
    } else {
      selectedRegister.value = null;
    }

    previousSelectionId.value = null;
    createRegister.value = false;
  };

  const items = ref(null);
  const selectedRegister = ref(null);
  const previousSelectionId = ref(null);
  const createRegister = ref(false);
  const ux = ref([]);
  const b_7315092382398562_noShow = computed(() => false);
  const b_7315092382398562_modalBindings = computed(() => ({
    size: 'lg',
  }));

  const $data = computed(() => ({
    items: items.value,
    selectedRegister: selectedRegister.value,
    previousSelectionId: previousSelectionId.value,
    createRegister: createRegister.value,
    ux: ux.value,
    b_7315092382398562_noShow: b_7315092382398562_noShow.value,
    b_7315092382398562_modalBindings: b_7315092382398562_modalBindings.value,
  }));

  const $$load_items = () => {
    return $fn.value.fetch('list_register');
  };
  const $$load_selectedRegister = () => {
    return items.value.length ? items.value[0] : null;
  };

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [
      { name: 'items' },
      { name: 'selectedRegister', dependsOn: ['items'] },
      { name: 'previousSelectionId' },
      { name: 'createRegister' },
      { name: 'ux' },
      { name: 'b_7315092382398562_noShow', nodeId: '7315092382398562' },
      { name: 'b_7315092382398562_modalBindings', nodeId: '7315092382398562' },
    ],
    loaders: { items: $$load_items, selectedRegister: $$load_selectedRegister },
    ux: {},
    dataRefs: {
      items,
      selectedRegister,
      previousSelectionId,
      createRegister,
      ux,
      b_7315092382398562_noShow,
      b_7315092382398562_modalBindings,
    },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  const pageDocument = computed(() => {
    return {
      title: $fn.value.pgettext('Registers|Title', 'Configure registers'),
    };
  });
  const documentTitle = computed(() => {
    return pageDocument.value
      ? Array.isArray(pageDocument.value.title)
        ? pageDocument.value.title.filter(Boolean).join(' ')
        : pageDocument.value.title
      : null;
  });

  watch(
    pageDocument,
    (newDoc) => {
      if (newDoc) {
        _pageDocument.value = newDoc;
      }
    },
    { immediate: true }
  );

  const act_7315092382398562_closeModal_pj4830n5n_getActionArgs = async (
    $event
  ) => {
    return {
      name: props.modalName,
      result: {
        close: true,
        cancel: true,
      },
    };
  };
  const act_3054425420812800_script_wj4typ2gg_value_callable = async (
    $event
  ) => {
    return (
      (createRegister.value = true),
      (previousSelectionId.value = selectedRegister.value?.id),
      (selectedRegister.value = null)
    );
  };
  const act_3054425420812800_script_wj4typ2gg_getActionArgs = async (
    $event
  ) => {
    return {
      value: async () => {
        await act_3054425420812800_script_wj4typ2gg_value_callable($event);
      },
    };
  };
  const act_814138253067422_script_nelc67r3t_value_callable = async (
    $event
  ) => {
    return (
      (createRegister.value = true),
      (previousSelectionId.value = selectedRegister.value?.id),
      (selectedRegister.value = null)
    );
  };
  const act_814138253067422_script_nelc67r3t_getActionArgs = async ($event) => {
    return {
      value: async () => {
        await act_814138253067422_script_nelc67r3t_value_callable($event);
      },
    };
  };
  const act_3774018224472797_script_9nwuh4dll_value_callable = async (
    $event
  ) => {
    return onRegisterSaved($event.data);
  };
  const act_3774018224472797_script_9nwuh4dll_getActionArgs = async (
    $event
  ) => {
    return {
      value: async () => {
        await act_3774018224472797_script_9nwuh4dll_value_callable($event);
      },
    };
  };
  const act_3774018224472797_script_05lonxzb2_value_callable = async (
    $event
  ) => {
    return onRegisterDeleted($event.data);
  };
  const act_3774018224472797_script_05lonxzb2_getActionArgs = async (
    $event
  ) => {
    return {
      value: async () => {
        await act_3774018224472797_script_05lonxzb2_value_callable($event);
      },
    };
  };

  const act_7315092382398562_closeModal_pj4830n5n =
    new actionTypes.CloseModalAction({
      actionArgs: act_7315092382398562_closeModal_pj4830n5n_getActionArgs,
    });
  const inst_evh_7315092382398562_close_w95lz5mu7 =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_closeModal_pj4830n5n,
      event: 'close',
      displayName: 'closeModal',
    });
  const inst_evh_7315092382398562_close = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_close_w95lz5mu7],
    event: 'close',
  });
  const act_7315092382398562_reloadComponentData_adxgc4vg2 =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_82h1oc1cz =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_adxgc4vg2,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_82h1oc1cz],
    event: 'reload',
  });
  const act_8564662037462133_closeModal_h8kxvn4dn =
    new actionTypes.CloseModalAction({});
  const inst_evh_8564662037462133_close_z6yt9q9yh =
    new actionTypes.EventHandlerImpl({
      action: act_8564662037462133_closeModal_h8kxvn4dn,
      event: 'close',
      displayName: 'closeModal',
    });
  const inst_evh_8564662037462133_close = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_8564662037462133_close_z6yt9q9yh],
    event: 'close',
  });
  const act_3054425420812800_script_wj4typ2gg = new actionTypes.ScriptAction({
    actionArgs: act_3054425420812800_script_wj4typ2gg_getActionArgs,
    displayName: 'addRegister',
  });
  const inst_evh_3054425420812800_clickPreventStop_ypdw5l2vj =
    new actionTypes.EventHandlerImpl({
      action: act_3054425420812800_script_wj4typ2gg,
      event: 'click.prevent.stop',
      displayName: 'addRegister',
    });
  const inst_evh_3054425420812800_clickPreventStop =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_3054425420812800_clickPreventStop_ypdw5l2vj],
      event: 'click.prevent.stop',
    });
  const act_814138253067422_script_nelc67r3t = new actionTypes.ScriptAction({
    actionArgs: act_814138253067422_script_nelc67r3t_getActionArgs,
    displayName: 'addRegister',
  });
  const inst_evh_814138253067422_clickPreventStop_wg3wnf0sp =
    new actionTypes.EventHandlerImpl({
      action: act_814138253067422_script_nelc67r3t,
      event: 'click.prevent.stop',
      displayName: 'addRegister',
    });
  const inst_evh_814138253067422_clickPreventStop =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_814138253067422_clickPreventStop_wg3wnf0sp],
      event: 'click.prevent.stop',
    });
  const act_3774018224472797_script_9nwuh4dll = new actionTypes.ScriptAction({
    actionArgs: act_3774018224472797_script_9nwuh4dll_getActionArgs,
  });
  const inst_evh_3774018224472797_saved_hsswj0w99 =
    new actionTypes.EventHandlerImpl({
      action: act_3774018224472797_script_9nwuh4dll,
      event: 'saved',
      displayName: 'script',
    });
  const inst_evh_3774018224472797_saved = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_3774018224472797_saved_hsswj0w99],
    event: 'saved',
  });
  const act_3774018224472797_script_05lonxzb2 = new actionTypes.ScriptAction({
    actionArgs: act_3774018224472797_script_05lonxzb2_getActionArgs,
  });
  const inst_evh_3774018224472797_deleted_55corbja0 =
    new actionTypes.EventHandlerImpl({
      action: act_3774018224472797_script_05lonxzb2,
      event: 'deleted',
      displayName: 'script',
    });
  const inst_evh_3774018224472797_deleted = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_3774018224472797_deleted_55corbja0],
    event: 'deleted',
  });
  const act_2140198529698299_closeModal_79iayhor7 =
    new actionTypes.CloseModalAction({});
  const inst_evh_2140198529698299_clickPreventStop_pnnvgki06 =
    new actionTypes.EventHandlerImpl({
      action: act_2140198529698299_closeModal_79iayhor7,
      event: 'click.prevent.stop',
      displayName: 'closeModal',
    });
  const inst_evh_2140198529698299_clickPreventStop =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_2140198529698299_clickPreventStop_pnnvgki06],
      event: 'click.prevent.stop',
    });

  const actions = {
    inst_evh_7315092382398562_close_w95lz5mu7,
    inst_evh_7315092382398562_close,
    inst_evh_7315092382398562_reload_82h1oc1cz,
    inst_evh_7315092382398562_reload,
    inst_evh_8564662037462133_close_z6yt9q9yh,
    inst_evh_8564662037462133_close,
    inst_evh_3054425420812800_clickPreventStop_ypdw5l2vj,
    addRegister: inst_evh_3054425420812800_clickPreventStop_ypdw5l2vj,
    inst_evh_3054425420812800_clickPreventStop,
    inst_evh_814138253067422_clickPreventStop_wg3wnf0sp,
    inst_evh_814138253067422_clickPreventStop,
    inst_evh_3774018224472797_saved_hsswj0w99,
    inst_evh_3774018224472797_saved,
    inst_evh_3774018224472797_deleted_55corbja0,
    inst_evh_3774018224472797_deleted,
    inst_evh_2140198529698299_clickPreventStop_pnnvgki06,
    inst_evh_2140198529698299_clickPreventStop,
  };

  const evh_7315092382398562_close_w95lz5mu7 = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_close_w95lz5mu7.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_close = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_close.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload_82h1oc1cz = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_82h1oc1cz.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8564662037462133_close_z6yt9q9yh = async (event, scope) => {
    return await actions.inst_evh_8564662037462133_close_z6yt9q9yh.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8564662037462133_close = async (event, scope) => {
    return await actions.inst_evh_8564662037462133_close.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3054425420812800_clickPreventStop_ypdw5l2vj = async (
    event,
    scope
  ) => {
    return await actions.inst_evh_3054425420812800_clickPreventStop_ypdw5l2vj.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3054425420812800_clickPreventStop = async (event, scope) => {
    return await actions.inst_evh_3054425420812800_clickPreventStop.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_814138253067422_clickPreventStop_wg3wnf0sp = async (
    event,
    scope
  ) => {
    return await actions.inst_evh_814138253067422_clickPreventStop_wg3wnf0sp.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_814138253067422_clickPreventStop = async (event, scope) => {
    return await actions.inst_evh_814138253067422_clickPreventStop.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3774018224472797_saved_hsswj0w99 = async (event, scope) => {
    return await actions.inst_evh_3774018224472797_saved_hsswj0w99.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3774018224472797_saved = async (event, scope) => {
    return await actions.inst_evh_3774018224472797_saved.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3774018224472797_deleted_55corbja0 = async (event, scope) => {
    return await actions.inst_evh_3774018224472797_deleted_55corbja0.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3774018224472797_deleted = async (event, scope) => {
    return await actions.inst_evh_3774018224472797_deleted.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_2140198529698299_clickPreventStop_pnnvgki06 = async (
    event,
    scope
  ) => {
    return await actions.inst_evh_2140198529698299_clickPreventStop_pnnvgki06.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_2140198529698299_clickPreventStop = async (event, scope) => {
    return await actions.inst_evh_2140198529698299_clickPreventStop.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    documentTitle,
    pageDocument: _pageDocument,
    routeTab,
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpPage
    :header="documentTitle"
    :loaded="loaded"
    :noShow="b_7315092382398562_noShow"
    :loading="showLoadingIndicator"
    :reloading="reloading"
    :error="error"
    :modal="modal"
    :modalBindings="b_7315092382398562_modalBindings"
    itp-cname="Registers"
    @close="evh_7315092382398562_close($event, {})"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <template #header>
      <UcHeader
        :card="!modal"
        :modal="modal"
        :title="documentTitle"
        v-if="loaded"
        @close="evh_8564662037462133_close($event, {})"
      >
      </UcHeader>
    </template>
    <UcBody :card="!modal" :modal="modal" v-if="loaded">
      <ItpBox direction="column">
        <ItpBox :gap="2" v-if="items.length">
          <ItpFormSearchableSelect
            name="register"
            v-model="selectedRegister"
            bind-object
            valueField="id"
            textField="name"
            :options="items"
            class="w-50"
          >
          </ItpFormSearchableSelect>
          <div>
            <ItpButton
              :text="pgettext('Registers', 'Add register...')"
              @click.prevent.stop="
                evh_3054425420812800_clickPreventStop($event, {})
              "
            >
            </ItpButton>
          </div>
        </ItpBox>
        <ItpBox
          direction="column"
          alignItems="center"
          v-if="items.length === 0 && !createRegister"
        >
          <p>
            {{ pgettext('Registers', 'No registers have been added yet.') }}
          </p>
          <ItpButton
            variant="primary"
            :text="pgettext('Registers', 'Create register...')"
            @click.prevent.stop="
              evh_814138253067422_clickPreventStop($event, {})
            "
          >
          </ItpButton>
        </ItpBox>
        <hr class="w-100" v-if="createRegister || selectedRegister" />
        <UcRegister
          :oid="createRegister ? null : selectedRegister.id"
          v-if="createRegister || selectedRegister"
          @saved="evh_3774018224472797_saved($event, {})"
          @deleted="evh_3774018224472797_deleted($event, {})"
        >
        </UcRegister>
      </ItpBox>
    </UcBody>
    <template #footer>
      <UcFooter :card="!modal" :modal="modal" v-if="loaded && modal">
        <ItpButton
          :text="gettext('Close')"
          variant="default"
          @click.prevent.stop="
            evh_2140198529698299_clickPreventStop($event, {})
          "
        >
        </ItpButton>
      </UcFooter>
    </template>
  </ItpPage>
</template>
